"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importStar(require("react"));
const Drawer_1 = __importDefault(require("@material-ui/core/Drawer"));
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const FullscreenExit_1 = __importDefault(require("@material-ui/icons/FullscreenExit"));
const Fullscreen_1 = __importDefault(require("@material-ui/icons/Fullscreen"));
const DragHandle_1 = __importDefault(require("@material-ui/icons/DragHandle"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const styles_1 = require("@material-ui/core/styles");
const Box_1 = __importDefault(require("../../../Box"));
const useStyles = styles_1.makeStyles((theme) => ({
    drawerPaper: {
        [theme.breakpoints.up('sm')]: {
            position: 'relative',
            width: '100%',
        },
        [theme.breakpoints.down('xs')]: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100%',
            zIndex: theme.zIndex.modal + 10,
        },
    },
    content: ({ height }) => ({
        height,
    }),
    dragHandle: {
        padding: 0,
        margin: 0,
        cursor: 'row-resize',
    },
    control: {
        position: 'absolute',
        right: 0,
        top: '5px',
        zIndex: 1,
        '& > button': {
            padding: 0,
            marginRight: '5px',
        },
        '& > button > span': {
            padding: 0,
            display: 'inline',
            lineHeight: 1.5,
        },
    },
    controlBar: {
        position: 'relative',
        display: 'flex',
        borderRadius: 0,
        backgroundColor: theme.palette.background.paper,
        borderTop: `1px solid ${theme.palette.grey['200']}`,
        minHeight: '40px',
    },
}));
const SplitPanel = ({ children, defaultSplitPanelHeight = 300, isSplitPanelOpen, setIsSplitPanelOpen, fullMode, }) => {
    const [height, setHeight] = react_1.useState(defaultSplitPanelHeight);
    const mouseMoveListener = react_1.useRef();
    const mouseUpListener = react_1.useRef();
    const styles = useStyles({
        height,
    });
    react_1.useEffect(() => {
        setHeight(defaultSplitPanelHeight);
    }, [defaultSplitPanelHeight]);
    const [minimized, setMinimized] = react_1.useState(false);
    const handleDrawerClose = react_1.useCallback(() => {
        setIsSplitPanelOpen(false);
    }, [setIsSplitPanelOpen]);
    const handleToggleResize = react_1.useCallback(() => {
        setMinimized((currentValue) => !currentValue);
    }, []);
    const handleMouseDown = react_1.useCallback(() => {
        const handleMouseMove = (e) => {
            const { offsetHeight, offsetTop } = document.body;
            const offsetBottom = offsetHeight - (e.clientY - offsetTop);
            const minHeight = 50;
            const maxHeight = offsetHeight * 0.5;
            if (offsetBottom > minHeight && offsetBottom < maxHeight) {
                setHeight(offsetBottom - minHeight);
            }
        };
        const handleMouseUp = () => {
            if (mouseMoveListener.current) {
                document.removeEventListener('mousemove', mouseMoveListener.current);
                mouseMoveListener.current = null;
            }
            if (mouseUpListener.current) {
                document.removeEventListener('mouseup', mouseUpListener.current);
                mouseUpListener.current = null;
            }
        };
        mouseUpListener.current = handleMouseUp;
        document.addEventListener('mouseup', mouseUpListener.current);
        mouseMoveListener.current = handleMouseMove;
        document.addEventListener('mousemove', mouseMoveListener.current);
    }, [setHeight]);
    return isSplitPanelOpen ? (react_1.default.createElement(Drawer_1.default, { variant: "persistent", anchor: "bottom", open: isSplitPanelOpen, classes: {
            paper: styles.drawerPaper,
        }, SlideProps: {
            timeout: 0,
        } },
        react_1.default.createElement(Box_1.default, { className: styles.controlBar },
            fullMode && (react_1.default.createElement(Box_1.default, { display: "flex", justifyContent: "center", width: "100%" }, !minimized && (react_1.default.createElement(IconButton_1.default, { "data-testid": "resize-split-panel", onMouseDown: handleMouseDown, className: styles.dragHandle },
                react_1.default.createElement(DragHandle_1.default, null))))),
            react_1.default.createElement(Box_1.default, { className: styles.control },
                fullMode && (react_1.default.createElement(IconButton_1.default, { "data-testid": "toggle-expand-split-panel", onClick: handleToggleResize }, minimized ? react_1.default.createElement(Fullscreen_1.default, null) : react_1.default.createElement(FullscreenExit_1.default, null))),
                react_1.default.createElement(IconButton_1.default, { "data-testid": "close-split-panel", onClick: handleDrawerClose },
                    react_1.default.createElement(Close_1.default, null)))),
        !minimized && (react_1.default.createElement(Box_1.default, { p: 1, overflow: "auto", className: styles.content, "data-testid": "content" }, children)))) : null;
};
exports.default = SplitPanel;
//# sourceMappingURL=index.js.map